import "../../styles/AdminDashboard.css";

function SoilDatasetsTab() {
  return (
    <div className="adminDash__panel adminDash__panel--datasets">
      <h2 className="adminDash__sectionTitle">Upload Soil Datasets</h2>
      <p className="adminDash__sectionText">
        Upload new soil survey CSV files to the platform. Files are processed and made available to
        authenticated users on the Map page.
      </p>

      {/* Upload area — wiring to storage is left as a next step */}
      <div className="adminDash__uploadZone">
        <p className="adminDash__uploadLabel">Drop a CSV file here, or click to browse</p>
        <p className="adminDash__uploadHint">Supports: .csv — max 50 MB</p>
        {/* TODO: wire to supabase.storage.from("datasets").upload(...) */}
        <button type="button" className="adminDash__uploadBtn">
          Select file
        </button>
      </div>
    </div>
  );
}

export default SoilDatasetsTab;
